'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileAttachmentIdsInHistory = undefined;

var _immutable = require('immutable');

var _fileAttachmentIdsInMessage = require('../../pubnub-message/operators/fileAttachmentIdsInMessage');

var _getMessages = require('./getMessages');

/**
 *
 * @param {ThreadHistory} threadHistory - thread history record
 * @returns {List<number>} list of file attachment ids in all
 *                         messages in history
 *
 */
var fileAttachmentIdsInHistory = exports.fileAttachmentIdsInHistory = function fileAttachmentIdsInHistory(threadHistory) {
  var messages = (0, _getMessages.getMessages)(threadHistory);

  return messages.reduce(function (ids, message) {
    var fileAttachmentids = (0, _fileAttachmentIdsInMessage.fileAttachmentIdsInMessage)(message);

    return ids.concat(fileAttachmentids);
  }, (0, _immutable.List)());
};